const ellipsisText = (name = '', limit = 30) => {
  let truncateTitle = name
  const charactersLimit = limit
  if (truncateTitle?.length > charactersLimit) {
    truncateTitle = name.substring(0, charactersLimit);
    truncateTitle = truncateTitle + '...'
  }
  return truncateTitle
};
export default ellipsisText;